import { Injectable } from '@angular/core';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service'; 
import { firstValueFrom } from 'rxjs';
import { WebOrder } from '../models/web-order.model';
import { WebOrderApprovals } from '../models/web-order-approvals.model';
import { WebProductAdmin } from '../models/web-product.model';
import { RequestParams } from '../../../common/rest-api/models/request-params';

@Injectable({
  providedIn: 'root',
})
export class WebOrderService extends RestApiService<WebOrder> {

  protected resourcePath = '/web-orders';
  protected modelType = WebOrder;

  async getOrders(fromDate: string, toDate: string, status: string): Promise<WebOrderApprovals[]> {

    const url = this.buildEndpointUrl(`get/${fromDate}/${toDate}/${status}`);

    const response = await this.cloudApiMiddleware.cloudRequest<WebOrderApprovals[]>({
      url
    }, 'GET');
    
    return response;
  }

  async getSystemAdminDetail(): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
   async updateSystemAdminDetail(settingAdmin:any): Promise<any> {

    const url = this.buildEndpointUrl(`system-admin/update`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
      body:settingAdmin
    }, 'POST');
    
    return response;
  }
  async cancelOrder(orderId: number, cancelReason: string): Promise<string> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`cancel/${orderId}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body: cancelReason
    }, 'POST');

    return response;
  }

  async transferOrders(orders: WebOrderApprovals[]): Promise<string> {
    //post to the transfer endpoint
    const url = this.buildEndpointUrl(`transfer`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body: orders
    }, 'POST');

    return response;
  }

  async imageUpload(file: File): Promise<string> {
  const url = this.buildEndpointUrl(`image/upload`);

  const formData = new FormData();
  formData.append('file', file); 

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body: formData
    }, 'POST');

    return response;
  }

  async getWebProductAdmin(params: RequestParams): Promise<any> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-product-admin/get`,params);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'GET');

    return response;
  }
   async getWebEmblemsAdmin(customerCode: string): Promise<any> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-emblems-admin/get/${customerCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'GET');

    return response;
  } 
   async getWebCustomerProduct(customerCode: string, productCode:string): Promise<any> {
    const url = this.buildEndpointUrl(`web-customer-product/get/${customerCode}/${productCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'GET');

    return response;
  }
   async updateWebCustomerProduct(custDepts:any,customerCode: string, productCode:string): Promise<string> {
    const url = this.buildEndpointUrl(`web-customer-product/update/${customerCode}/${productCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body:custDepts
    }, 'POST');

    return response;
  }
   async deleteWebCustomerProduct(customerCode: string, productCode:string): Promise<string> {
    const url = this.buildEndpointUrl(`web-customer-product/delete/${customerCode}/${productCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
    }, 'GET');

    return response;
  }
    async getWebProduct(productCode: string, productType:number,action:boolean): Promise<any> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-product-admin/get/${productCode}/${productType}/${action}`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'GET');

    return response;
  }

    async getWebProductImages(): Promise<any> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-product-edit/get`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url,
    }, 'GET');

    return response;
  }
  async updateProductItems(webProduct: WebProductAdmin): Promise<string> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-product-edit/update`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body:webProduct,
    }, 'POST');

    return response;
  }
    async deleteProductItems(productCode: string,productType:number): Promise<string> {
    //post to the cancel endpoint
    const url = this.buildEndpointUrl(`web-product-edit/delete/${productCode}/${productType}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
    }, 'GET');

    return response;
  }
    async  getWebOrderState(): Promise<any> {
        const url = this.buildEndpointUrl(`state`);
       const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }
    async getWoOrders(fromDate: string, toDate: string): Promise<any> {

    const url = this.buildEndpointUrl(`wo/get/${fromDate}/${toDate}`);

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');
    
    return response;
  }

}